/* tslint:disable */
/* eslint-disable */
/* @relayHash a642a0196414a633fd1a849f60408312 */

import { ConcreteRequest } from "relay-runtime";
export type mutationsDeleteEntryMutationVariables = {
    id: string;
};
export type mutationsDeleteEntryMutationResponse = {
    readonly deleteQWEEntry: boolean;
};
export type mutationsDeleteEntryMutation = {
    readonly response: mutationsDeleteEntryMutationResponse;
    readonly variables: mutationsDeleteEntryMutationVariables;
};



/*
mutation mutationsDeleteEntryMutation(
  $id: ID!
) {
  deleteQWEEntry(input: {id: $id})
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "id",
            "type": "ID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "deleteQWEEntry",
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ]
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "mutationsDeleteEntryMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "mutationsDeleteEntryMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "mutationsDeleteEntryMutation",
            "id": null,
            "text": "mutation mutationsDeleteEntryMutation(\n  $id: ID!\n) {\n  deleteQWEEntry(input: {id: $id})\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'e54debdc98bd70e8864f764b16fbbdfc';
export default node;
